__turbopack_context__.v({
  "add-to-cart": "AddToCartButton-module__sjwTzW__add-to-cart",
  "blok-big-title": "AddToCartButton-module__sjwTzW__blok-big-title",
  "blok-subtitle": "AddToCartButton-module__sjwTzW__blok-subtitle",
  "blok-title": "AddToCartButton-module__sjwTzW__blok-title",
  "discountedPrice": "AddToCartButton-module__sjwTzW__discountedPrice",
  "large": "AddToCartButton-module__sjwTzW__large",
  "mobile": "AddToCartButton-module__sjwTzW__mobile",
  "wrapper": "AddToCartButton-module__sjwTzW__wrapper",
});
